import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { autoUpdate, shift, useFloating } from '@floating-ui/react';
import { NavigationMenu, NavigationMenuItem } from '@radix-ui/react-navigation-menu';
import { useBreakpointUp } from '@travel-frontend/core';
import { IconAccountCircle } from '@travel-frontend/icons';
import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { DropdownMenu } from '../../components/AccountControl/components/DropdownMenu/DropdownMenu.js';
import { MenuList } from '../../components/AccountControl/components/MenuList.js';
import { Trigger } from '../../components/AccountControl/components/Trigger.js';
import { AuthenticationWidget } from '../../components/Authentication/index.js';
import { useAuthentication } from '../../hooks/index.js';
import { Avatar, LabelSmall, Skeleton } from '../../primitives/index.js';
import { HEADER_QA_ID, qaId } from '../../utils/qaId.js';
export const AccountControl = ({
  onLogout,
  enableCaptionForAnonymous
}) => {
  const isLargeScreen = useBreakpointUp('xl');
  const {
    t
  } = useTranslation('headerNew');
  const {
    isLoggedIn,
    userInfo,
    getUserStatus
  } = useAuthentication();
  const {
    firstName,
    lastName,
    initials
  } = userInfo || {};
  const {
    refs,
    floatingStyles
  } = useFloating({
    whileElementsMounted: autoUpdate,
    strategy: 'fixed',
    middleware: [shift()],
    placement: 'bottom'
  });
  useEffect(() => {
    getUserStatus();
  }, []);
  return _jsxs(_Fragment, {
    children: [!isLoggedIn && _jsx(AuthenticationWidget, {
      onSuccessSignIn: getUserStatus
    }), _jsx(NavigationMenu, {
      children: _jsx(MenuList, {
        children: _jsxs(NavigationMenuItem, {
          ref: refs.setReference,
          children: [_jsx(Trigger, {
            "data-testid": qaId(HEADER_QA_ID, 'headercontrol', 'login'),
            "data-clarity-mask": "true",
            children: isLoggedIn ? _jsxs(_Fragment, {
              children: [_jsx(Avatar, {
                initials: initials,
                "data-testid": qaId(HEADER_QA_ID, 'headercontrol', 'avatar')
              }), isLargeScreen && (firstName && lastName ? _jsx(LabelSmall, {
                truncate: true,
                color: "contentInversePrimary",
                "data-testid": qaId(HEADER_QA_ID, 'headercontrol', 'fullname'),
                children: `${firstName} ${lastName}`
              }) : _jsx(Skeleton, {
                variant: "text",
                width: 70,
                height: 20
              }))]
            }) : _jsxs(_Fragment, {
              children: [_jsx(IconAccountCircle, {}), enableCaptionForAnonymous && t('headerNew:login.myAccount')]
            })
          }), _jsx(DropdownMenu, {
            onLogout: onLogout,
            "data-testid": qaId(HEADER_QA_ID, 'headercontrol', 'burgermenu'),
            ref: refs.setFloating,
            style: floatingStyles
          })]
        })
      })
    })]
  });
};